import * as React from 'react'

import { useSelector } from 'react-redux'

import BrandFansHeader from '@components/BrandFans/Header'
import InfluencerIdentityList from '@components/BrandFans/InfluencerIdentity/List'
import { BrandFanFilters } from '@enums'
import { withRememberScrollPosition } from '@hocs'
import { IApplicationState } from '@store'
import { selectBrandFansStats, selectIsListEmpty, selectStatByFilter } from '@store/brandFans'
import { selectCurrentBrandFansFilter } from '@store/router'
import InfluencerIdentityGroupList from '../Group/List'
import { IdentitiesPageSubHeader } from '../Header/SubHeader'
import BrandFansInfluencerIdentityTopPanel from '../InfluencerIdentity/TopPanel'
import BrandFansContentUnsupportedScreenHandler from './UnsupportedScreenHandler'

const BrandFansContent: React.FC = () => {
  const currentFilter = useSelector((state: IApplicationState) =>
    selectCurrentBrandFansFilter(state),
  )
  const brandFanStats = useSelector((state: IApplicationState) => selectBrandFansStats(state))
  const hasEmpyList = useSelector((state: IApplicationState) =>
    selectIsListEmpty(state, currentFilter),
  )
  const statsLoaded = useSelector((state: IApplicationState) =>
    Boolean(selectStatByFilter(state, currentFilter)),
  )

  if (currentFilter === BrandFanFilters.Groups) {
    return (
      <BrandFansContentUnsupportedScreenHandler>
        <BrandFansHeader
          type={BrandFanFilters.Groups}
          count={brandFanStats[BrandFanFilters.Groups]}
        >
          <IdentitiesPageSubHeader hasEmpyList={hasEmpyList} type={BrandFanFilters.Groups} />
        </BrandFansHeader>
        <InfluencerIdentityGroupList />
      </BrandFansContentUnsupportedScreenHandler>
    )
  }

  return (
    <BrandFansContentUnsupportedScreenHandler>
      <BrandFansHeader type={currentFilter} count={brandFanStats[currentFilter]}>
        <IdentitiesPageSubHeader hasEmpyList={hasEmpyList} type={currentFilter} />
      </BrandFansHeader>
      {!hasEmpyList && statsLoaded && <BrandFansInfluencerIdentityTopPanel />}
      <InfluencerIdentityList filter={currentFilter} />
    </BrandFansContentUnsupportedScreenHandler>
  )
}

export { BrandFansContent }
export default withRememberScrollPosition(BrandFansContent)
